<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 240" preserveAspectRatio="none">
  <defs><style>.wave_svg_path{fill:currentColor;}</style></defs>
  <path class="wave_svg_path" d="M0,240V66.1c0,0,17.3-14.3,28-23.3c21.7-18.4,56.6-16.7,77,0c9.4,7.8,15.2,12,23,18.3c10.8,8.7,32.1,8.2,39,1
	c14.9-15.7,24.4-26.9,36-39.6c21.8-23.9,42.4-25.3,69-1c17.5,15.9,36.6,34.3,57,50.7c20.8,16.7,61.6,17.2,82-1
	c24.6-22.1,37.9-35.5,61-55.8c23.7-20.9,56.7-20.4,82,1c17.7,15,41,36.3,54,47.7s34.2,11.4,44,3c19.3-16.3,39.9-19.9,62,2
	c10.1,10,11.6,11.4,21,19.3c13.5,11.2,36.5,12.4,49,2c14-11.6,29.8-27.1,45-43.5c14.9-16.2,40.1-17.1,60.8,1.2
	c8.3,7.3,8.3,7.5,15.2,14c11.5,10.7,26.4,10.3,37,0c12.3-11.9,31.9-33,46-47.7c14.3-14.9,41.2-17.6,59,0c15.9,15.7,57.3,56.4,71,69
	c14,12.9,41,12.5,58.6,0.1c17.4-12.3,23.4-17.4,23.4-17.4V240H0z"/>
</svg>
